import { useMemo, useState } from 'react';
import NewsCard from '@/components/feature/NewsCard';
import EmptyState from '@/components/base/EmptyState';
import { newsList } from '@/mocks/news';

const PAGE_SIZE = 4;

export default function NewsCategory() {
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  const sorted = useMemo(
    () => [...newsList].sort((a, b) => (a.date < b.date ? 1 : -1)),
    [],
  );

  const visible = sorted.slice(0, visibleCount);
  const hasMore = visibleCount < sorted.length;

  if (sorted.length === 0) {
    return (
      <EmptyState
        icon="ri-newspaper-line"
        title="暂无花絮内容"
        description="花絮资讯正在整理中，稍后再来看看吧。"
        actionLabel="返回首页"
        actionTo="/"
      />
    );
  }

  return (
    <div>
      <div className="mb-4 flex items-center justify-between text-sm text-foreground-500">
        <span>
          已显示 <strong className="text-primary-600">{visible.length}</strong> / {sorted.length} 篇花絮
        </span>
        <span className="flex items-center gap-1">
          <i className="ri-time-line" />
          按发布时间排序
        </span>
      </div>

      <div className="space-y-4">
        {visible.map((news) => (
          <NewsCard key={news.id} news={news} variant="row" />
        ))}
      </div>

      {hasMore ? (
        <div className="mt-8 flex justify-center">
          <button
            type="button"
            onClick={() => setVisibleCount((prev) => prev + PAGE_SIZE)}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-500"
          >
            <i className="ri-arrow-down-s-line text-lg" />
            加载更多花絮
          </button>
        </div>
      ) : (
        <p className="mt-8 text-center text-sm text-foreground-400">—— 已经到底啦，更多花絮敬请期待 ——</p>
      )}
    </div>
  );
}